import axiosStatic from "axios";
import {ClientAuthError} from 'msal';
import { config } from '../config';
import { firebaseService } from "./firebaseService";

export const axios = axiosStatic.create({
    baseURL: config.apiUrl
});

// Second axios instance for elgin azure api with different base URL
export const axiosAzureAPI = axiosStatic.create({
    baseURL: config.azureApiUrl,
});

axios.interceptors.request.use(async requestConfig => {
    if (requestConfig.url?.startsWith('/')) {
        try {
            const accessToken = await firebaseService.auth().currentUser?.getIdToken();
            if (accessToken) {
                requestConfig.headers["Authorization"] = `Bearer ${accessToken}`;
            }
        } catch (e) {
            // if the error is ClientAuthError, we do NOT want to throw
            // instead, perform the request without an Authorization header
            if ((e as ClientAuthError).name !== "ClientAuthError") {
                throw e;
            }
        }
    }
    return requestConfig;
});

// Apply the same interceptors to the localhost axios instance
axiosAzureAPI.interceptors.request.use(async requestConfig => {
    if (requestConfig.url?.startsWith('/')) {
        try {
            const accessToken = await firebaseService.auth().currentUser?.getIdToken();
            if (accessToken) {
                requestConfig.headers["Authorization"] = `Bearer ${accessToken}`;
            }
            console.log(`[DIAG] axiosAzureAPI request: ${requestConfig.method?.toUpperCase()} ${requestConfig.baseURL}${requestConfig.url}`, { hasToken: !!accessToken });
        } catch (e) {
            console.warn('[DIAG] axiosAzureAPI request interceptor error:', (e as Error).message);
            // if the error is ClientAuthError, we do NOT want to throw
            // instead, perform the request without an Authorization header
            if ((e as ClientAuthError).name !== "ClientAuthError") {
                throw e;
            }
        }
    }
    return requestConfig;
});

axios.interceptors.response.use(
    async response => {
        return response;
    },
    async error => {
        console.error('[DIAG] axios (legacy API) response error:', {
            url: error.config?.baseURL ? `${error.config.baseURL}${error.config.url}` : error.config?.url,
            method: error.config?.method?.toUpperCase(),
            status: error.response?.status,
            statusText: error.response?.statusText,
            responseData: error.response?.data,
            message: error.message,
            code: error.code,
        });
        return Promise.reject(error);
    }
);

axiosAzureAPI.interceptors.response.use(
    async response => {
        return response;
    },
    async error => {
        console.error('[DIAG] axiosAzureAPI response error:', {
            url: error.config?.baseURL ? `${error.config.baseURL}${error.config.url}` : error.config?.url,
            method: error.config?.method?.toUpperCase(),
            status: error.response?.status,
            statusText: error.response?.statusText,
            responseData: error.response?.data,
            message: error.message,
            code: error.code,
        });
        return Promise.reject(error);
    }
);

export class AxiosService {
    private static staticAxios = axios;

    protected get axios() {
        return AxiosService.staticAxios;
    }

    protected constructor() {}
}